
export function groupArrayOfObjects(array,index)
{
    return  array.reduce(function (r, a) {
              r[a[index]] = r[a[index]] || [];
              r[a[index]].push(a);
              return r;
          }, Object.create(null));
}


export function lastIndexUndefined(array)
{
    let index = 0
    for (let i = 0; i < array.length; i++) {
      
      if (typeof array[i] !== 'undefined') 
      {
        index  = i>0 ? (i-1):i
        break;
      }
    }

    return index
}


export function undefinedIndexArrayToZero(array,index)
{
    if (typeof array[index] === 'undefined') 
    {
      array[index] = 0
    }
}


export function averageArray(array,count)
{
    for (let i = 0; i < array.length; i++) {
              
      if (typeof array[i] !== 'undefined') 
      {
        array[i] = array[i]/count
      }
    }
}

